import type { EmbeddingMessageType } from '../../../types/embedding';
import { createMessage } from './messaging';

export function broadcastToEmbeddedServices(
  type: EmbeddingMessageType,
  payload: unknown,
  targetOrigin?: string
): void {
  if (typeof document === 'undefined') {
    return;
  }

  const message = createMessage(type, payload);
  const iframes = document.querySelectorAll('iframe');

  iframes.forEach((iframe) => {
    try {
      const resolvedOrigin = targetOrigin ?? new URL(iframe.src, window.location.href).origin;
      iframe.contentWindow?.postMessage(message, resolvedOrigin);
    } catch (error) {
      console.warn('Failed to broadcast shell message to embedded iframe', error);
    }
  });
}

export function broadcastShellLogout(): void {
  broadcastToEmbeddedServices('custom', { event: 'shell-logout' });
}
